import type { UIMessage } from "ai";

export function appendAssistantTextMessage(messages: UIMessage[], text: string): UIMessage[] {
  const trimmed = text.trim();
  if (!trimmed) return messages;
  return [
    ...messages,
    {
      id: globalThis.crypto?.randomUUID?.() ?? `assistant-${Date.now()}`,
      role: "assistant",
      parts: [{ type: "text", text: trimmed }],
    },
  ];
}
